// removed by extract-text-webpack-plugin
module.exports = {"product-intro-wrapper":"main_nav-1HN","product-intro-lockup":"main_nav-1Wh","product-intro-icon":"main_nav-3Kx","header-text":"main_nav-363","product-intro-button-wrapper":"main_nav-1qg","product-intro-button":"main_nav-2v9"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Submenu/Intro/Product/product_intro.module.scss
// module id = 357
// module chunks = 0